import { createSignal, JSXElement, ParentProps, splitProps } from 'solid-js'
import styles from './st-group-box.module.css'

export class GroupBoxProps {
    label: JSXElement
    class?: string
}

export default function GroupBox(props: ParentProps<GroupBoxProps>) {
    const [local, others] = splitProps(props, ['label', 'class']);

    const [isOpen, setIsOpen] = createSignal(true);
    
    return (
        <div class={styles['st-group-box']} data-open={isOpen()}>
            <div class={styles['st-group-box-label']} onClick={() => setIsOpen(!isOpen())}>
                <span
                    class='fa'
                    classList={{
                        'fa-chevron-right': !isOpen(),
                        'fa-chevron-down': isOpen()
                    }}
                    style='margin-right: 0.5rem;'
                ></span>
                {props.label}
            </div>
            <div class={`${styles['st-group-box-content']} ${local.class ?? ''}`} >
                {props.children}
            </div>
        </div>
    );
}

GroupBox.defaultProps = new GroupBoxProps();